<template>
  <div class="dialog-container weekBox">
    <el-dialog
      :title="`${isEdit ? $t('edit') : $t('add')}`"
      :visible.sync="show"
      :before-close="closeDialog"
      @opened="openedDialog"
      center
      :close-on-click-modal="false"
      width="700px">
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="VR名称" prop="vrName">
              <el-input clearable v-model="form.vrName" placeholder="最多20个字" :maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="VR图片" prop="completePath">
              <el-upload
                class="upload"
                :show-file-list="false"
                :with-credentials="true"
                :action="ImageUpload"
                :httpRequest="(e) => { uploadHttpDefault(e, true) }"
                name="file"
                accept=".png,.jpg"
                ref="upload"
                :on-success="uploadSuccess"
                :on-error="uploadError">
                  <img v-if="form.completePath" class="image-upload" :src="form.completePath" alt="" srcset="" width="78" height="78">
                  <img v-else class="image-upload" src="@/assets/images/upload_image.png" alt="" srcset="">
                  <div class="upload-images-tip">
                    图片尺寸不小于690x388px，图片格式png/jpg
                  </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="VR位置" prop="point" :required="true">
              <div class="bmap-wrap">
                <new-map v-if="showMap" ref="bMap" :address="form.mapAnnotation" :point.sync="form.point" :isEdit="isEdit" @getPoint="onGetPoint" @getAddress="getMapPoint" height="300px"></new-map>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="VR地址" prop="vrPath">
              <el-input clearable v-model="form.vrPath"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排列顺序" prop="sort">
              <el-input type="number" min="1" clearable v-model="form.sort" oninput="if(value>10000)value=10000"></el-input>
              <div style="color:rgba(168,168,168,1);font-size:12px;">数值越小越靠前</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="置顶" prop="top">
              <el-radio v-model="form.top" label="Y">置顶</el-radio>
              <el-radio v-model="form.top" label="N">不置顶</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button class="footer-confirm" @click="sureEvent">{{$t('sure')}}</el-button>
        <!-- 如果没特别需求，统一使用mixin里面的关闭方法 -->
        <el-button class="footer-cancel" @click="closeDialog">{{$t('cancel')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import mixin from '@/mixins/dialogMixin'
import AddDialogClass from './addDialogClass'
import newMap from "./bMap.vue";
import apis from '@/apis'

export default {
  mixins: [mixin],
  props: {
    show: {
      required: true,
      type: Boolean,
    },
    isEdit: {
      required: true,
      type: Boolean,
    },
    Language: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  components: {
    newMap,
  },
  data() {
    return {
      flag: false,
      form: new AddDialogClass('form'), // 实例化一个表单的变量
      rules: new AddDialogClass('rule', this.Language), // 实例化一个表单的规则
      showPic: true,
      showMap: true,
      ImageUpload: apis.ImageUpload,
    }
  },
  computed: {
    ...mapState(['DROPDOWNBOX', "TOKEN"]),
  },
  methods: {
    uploadSuccess(res) {
      this.form.completePath = res.data.url
      this.form.vrPic = res.data.path
      this.$refs.form.validateField("completePath");
    },
    uploadError(res) {
      console.log(res)
    },
    /**
     * @function 关闭弹窗
     * @description 先初始化，然后传值到组件外部进行关闭
     **/
    async closeDialog() {
      await this.init()
      this.$refs.bMap.clearData();
      this.$emit('closeDialog', false)
    },
    /**
     * @function 初始化弹窗
     */
    init() {
      this.$refs.form.resetFields()
      this.form = new AddDialogClass('form')
      // this.$refs.bMap.init()
      this.$refs.upload.clearFiles();
      console.log(this.form)
      console.log('我初始化了')
    },
    getMapPoint(region) {
      console.log("getMapPonit -> region", region)
      this.form.region = region;
    },
    onGetPoint(point, address) {
      console.log("onGetPoint -> point", point)
      this.form.point.lat = point.lat;
      this.form.point.lng = point.lng;
      this.form.mapAnnotation = address;
    },
    /**
     * @function 点击确定按钮，先执行业务，完了调关闭方法，不要写两次关闭方法
     */
    sureEvent() {
      // 这里写业务需求
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.flag) { return }
          this.flag = true
          this.form.latitude = this.form.point.lat;
          this.form.longitude = this.form.point.lng;
          if (this.isEdit) {
            this.$http.put(apis.updataVr, this.form).then((res) => {
              if (res.data.code === 0) {
                // 调用关闭方法，不要再写一次
                this.flag = false
                this.closeDialog()
              } else {
                this.flag = false
              }
            })
          } else {
            this.$http.post(apis.addVr, this.form).then((res) => {
              if (res.data.code === 0) {
                // 调用关闭方法，不要再写一次
                this.flag = false
                this.closeDialog()
              } else {
                this.flag = false
              }
            })
          }
        }
      })
      console.log(`我执行了点确定的业务需求`)
    },
    /**
     * @function 回显的时候获取数据
     * @param {Object} data 要传输给后端的数据
     */
    getDataQuery(data) {
      // 在这里获取回显的数据
      this.$http.get(`${apis.queryVr}/${data.id}`).then((res) => {
        console.log("++++++++++++:", res.data.data)
        if (res.data.code === 0) {
          this.form = {
            ...this.form,
            ...res.data.data,
            point: {
              lng: Number(res.data.data.longitude),
              lat: Number(res.data.data.latitude),
            },
          }
          console.log("===========this.form:", this.form);
          //this.showMap = true
          //this.$refs.bMap.init(Number(res.data.data.longitude), Number(res.data.data.latitude))
          //修改
          this.showMap = false
          this.$nextTick(() => {
            this.showMap = true
          })
        }
      })
    },
    openedDialog() {
      this.showMap = false
      this.$nextTick(() => {
        this.showMap = true
      })
    },
  },
}
</script>
<style lang="less" scoped>
.image-upload {
  width: 50px;
  height: 50px;
}
.upload-images-tip {
  color:rgba(168,168,168,1);
  font-size:12px;
  margin-top: -15px;
}
.image-wrap{
  width: 50px;
  height: 50px;
  margin-right: 10px;
  position: relative;
  float: left;
  .images-close {
    position: absolute;
    right: -7px;
    top: -7px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
.bmap-wrap {
  width: 100%;
}
/deep/input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none!important;
}
input[type="number"]{
    -moz-appearance: textfield;
}
</style>
<style lang="less">
@import "../../../assets/styles/mixin.less";
</style>
